(() => {
  const root = document.querySelector('[data-minty-story]');
  if (!root) return;
  const body = root.querySelector('[data-minty-body]');
  const headings = [...body.querySelectorAll('h2')];
  const toc = root.querySelector('[data-minty-toc]');
  if (headings.length >= 4 && toc) {
    const list = toc.querySelector('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `minty-section-${index + 1}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      const item = document.createElement('li');
      item.append(link);
      list.append(item);
    });
    toc.hidden = false;
  }

  const printButton = root.querySelector('[data-minty-print]');
  if (printButton) {
    printButton.hidden = false;
    printButton.addEventListener('click', () => window.print());
  }
  const suggestion = root.querySelector('#djws-suggestion');
  const revealSuggestion = () => {
    if (!suggestion) return;
    if (location.hash === '#djws-suggestion' || suggestion.querySelector(location.hash && /^#[A-Za-z][\w-]*$/.test(location.hash) ? location.hash : '[role="alert"], [role="status"]')) {
      suggestion.open = true;
    }
  };
  root.querySelector('a[href="#djws-suggestion"]')?.addEventListener('click', () => { suggestion.open = true; });
  window.addEventListener('hashchange', revealSuggestion);
  revealSuggestion();
  const firstHeading = headings[0];
  const jump = root.querySelector('[data-minty-jump]');
  if (firstHeading && jump) {
    if (!firstHeading.id) firstHeading.id = 'minty-guide-start';
    jump.href = `#${firstHeading.id}`;
  }
  root.querySelectorAll('[data-minty-share], [data-minty-copy]').forEach((control) => {
    control.hidden = false;
    const status = control.closest('[data-minty-share-group]').querySelector('[data-minty-share-status]');
    const showManualLink = () => {
      const input = document.createElement('input');
      input.type = 'text';
      input.readOnly = true;
      input.value = control.dataset.canonical;
      input.setAttribute('aria-label', control.dataset.manualLabel);
      status.replaceChildren(input);
      input.focus();
      input.select();
    };
    control.addEventListener('click', async () => {
      const url = control.dataset.canonical;
      const title = root.querySelector('h1').textContent;
      try {
        if (control.hasAttribute('data-minty-share') && navigator.share) {
          await navigator.share({ title, text: control.dataset.shareText, url });
          window.MintyEditorialEvents?.publish('share_completed');
        } else {
          await navigator.clipboard.writeText(url);
          status.textContent = control.dataset.copiedLabel;
          window.MintyEditorialEvents?.publish('link_copied');
        }
      } catch (error) {
        if (error.name !== 'AbortError') showManualLink();
      }
    });
  });
})();
